module.exports = __webpack_public_path__ + "static/crieBG-0735e0e07e2fa0a2913e0a2b5e3f0ca5.jpg";